"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@c3po/i18n");
const badge_1 = __importDefault(require("./components/badge"));
const timer_1 = __importDefault(require("./components/timer"));
const trigger_1 = require("./styles/trigger");
const CART = '/cart';
const defaultOnRouting = (url) => (window.location.href = url);
const Trigger = ({ expirationDate, totalUnits, onExpiration, transparent, open, expired, empty, onRouting = defaultOnRouting, isCartPage = false, }) => {
    const { i18n, translations } = (0, i18n_1.useTranslate)() || {};
    const handleClick = () => {
        if (!isCartPage)
            onRouting(CART);
    };
    const handleBtnClick = (e) => {
        e.preventDefault();
    };
    return ((0, jsx_runtime_1.jsxs)(trigger_1.TriggerContainer, { isTransparent: transparent, open: open, onClick: handleClick, children: [(0, jsx_runtime_1.jsx)(trigger_1.IconCart, { height: "24px", width: "24px" }), translations && i18n && empty && (0, jsx_runtime_1.jsx)(trigger_1.Label, { children: i18n('cart_widget.title') }), (0, jsx_runtime_1.jsx)(timer_1.default, { expirationDate: expirationDate, onExpiration: onExpiration, transparent: transparent, expired: expired }), (0, jsx_runtime_1.jsx)(badge_1.default, { totalUnits: totalUnits }), (0, jsx_runtime_1.jsx)(trigger_1.Anchor, { href: CART, onClick: handleBtnClick })] }));
};
exports.default = Trigger;
